import React from 'react'
import {HeroContainer, HeroWrapper, HeroText, HeroContent, HeroP} from "./HeroServiceElement"
// import img from "../../Images/s2.png"

const HeroService = () => {
    return (
        <HeroContainer>
            <HeroWrapper>
            <HeroContent>
                <HeroText>SERVICES</HeroText>                
                <HeroP>Services we offer</HeroP>
                </HeroContent>
            </HeroWrapper>
        </HeroContainer>
    )
}

export default HeroService

